"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVisualizationResource = createVisualizationResource;
const moment_1 = __importDefault(require("moment"));
const visualization_schema_1 = require("@varos/visualization-schema");
function createVisualizationResource(client, config) {
    const { options: globalOptions } = config;
    const FORMAT = 'YYYY-MM-DD';
    return {
        async create(payload, options = {}) {
            const response = await client.post(`/visualizations`, {
                ...payload,
                query: {
                    ...payload.query,
                    period: payload.query.period && (0, visualization_schema_1.isAbsolutePeriod)(payload.query.period)
                        ? {
                            start: (0, moment_1.default)(payload.query.period.start).format(FORMAT),
                            end: (0, moment_1.default)(payload.query.period.end).format(FORMAT),
                        }
                        : payload.query.period,
                },
            }, {
                params: { 'api-key': options.apikey ?? undefined },
                headers: { ...globalOptions?.headers, ...(options.headers ?? {}) },
            });
            // const parsed = VisualizationObjectSchema.parse(response.data);
            return response.data;
        },
    };
}
//# sourceMappingURL=visualizationResource.js.map